import React, { FC } from 'react'
import { testId } from '@lojinha/helpers'
import { Box, Text, Stack } from '@lojinha/design-system'
import { t } from '../../../dictionary'

type DescriptionProps = {
  description: string | null
}

export const Description: FC<DescriptionProps> = ({ description = '' }) => {
  if (!description) {
    return null
  }

  return (
    <Stack margin="x24" {...testId('marketable-product-details')}>
      <Text isBrand textTransform="uppercase">
        {t.description}
      </Text>
      <Box>
        <Text>{description}</Text>
      </Box>
    </Stack>
  )
}
